
import { send_bienlai_rq, send_bienlai_rq_multiple } from "../models/request/bien-lai/send_bienlai_rq";
import { apiClient } from "./apiClient";

export const SF_BIENLAI_PRINT = "sf_bienlaithu/print"
export const SF_BIENLAI_PRINT_THONGBAOPHI = "sf_bienlaithu/print_thongbaophi"
export const SF_BIENLAI_EXPORT_THONGBAOPHI_EXCEL = "sf_bienlaithu/export_thongbaophi_excel"
export const SF_BIENLAI_SEND = "sf_bienlaithu/send_bienlai"
export const SF_BIENLAI_SEND_THONGBAOPHI = "sf_bienlaithu/send_thongbaophi"
export const SF_BIENLAI_SEND_MULTIPLE = "sf_bienlaithu/send_bienlai_multiple"
export const SF_BIENLAI_SENDTHUXACNHAN = "sf_bienlaithu/send_thuxacnhan"
export const SF_BIENLAI_UPDATENGAYTHU = "sf_bienlaithu/update-ngaythu"
export const SF_BIENLAI_GETBYCHUNGTU = "sf_bienlaithu/get-by-sochungtu?so_chung_tu="
export const SF_BIENLAI_GET_EMAIL_CONTENT = "sf_bienlaithu/get_email_content"
export const SF_BIENLAI_GET_THONGBAOPHI_EMAIL_CONTENT = "sf_bienlaithu/get_thongbaophi_email_content"

export const bienLaiThuApi = {
    print: (data: any) => apiClient.post(`${SF_BIENLAI_PRINT}`, data),
    print_thongbaophi: (data: any) => apiClient.post(`${SF_BIENLAI_PRINT_THONGBAOPHI}`, data),
    export_thongbaophi_excel: (data: any) => apiClient.postBlob(`${SF_BIENLAI_EXPORT_THONGBAOPHI_EXCEL}`, data),
    send_bienlai: (data: send_bienlai_rq) => apiClient.post(`${SF_BIENLAI_SEND}`, data),
    send_thongbaophi: (data: send_bienlai_rq) => apiClient.post(`${SF_BIENLAI_SEND_THONGBAOPHI}`, data),
    update_ngaythu: (data: any) => apiClient.post(`${SF_BIENLAI_UPDATENGAYTHU}`, data),
    get_by_chungtu: (so_chung_tu: string) => apiClient.get(`${SF_BIENLAI_GETBYCHUNGTU}` + so_chung_tu),
    send_thuxacnhan: (data: send_bienlai_rq) => apiClient.post(`${SF_BIENLAI_SENDTHUXACNHAN}`, data),
    send_bienlai_multiple: (data: send_bienlai_rq_multiple) => apiClient.post(`${SF_BIENLAI_SEND_MULTIPLE}`, data),
    get_email_content: (sf_mucphaithu_id: number) => apiClient.post(`${SF_BIENLAI_GET_EMAIL_CONTENT}`, { sf_mucphaithu_id }),
    get_thongbaophi_email_content: (sf_mucphaithu_id: number) => apiClient.post(`${SF_BIENLAI_GET_THONGBAOPHI_EMAIL_CONTENT}`, { sf_mucphaithu_id }),
}
